import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/images/map/icon01.png';
import _imports_1 from '@/assets/images/map/icon02.png';
import _imports_2 from '@/assets/images/map/icon03.png';
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  key: 0,
  class: "level1 flex items-center"
};
const _hoisted_3 = {
  class: "level1-item flex items-center"
};
const _hoisted_4 = {
  class: "num"
};
const _hoisted_5 = {
  class: "unit"
};
const _hoisted_6 = {
  class: "level1-item flex items-center"
};
const _hoisted_7 = {
  class: "num"
};
const _hoisted_8 = {
  key: 1,
  class: "level h-full flex items-center"
};
const _hoisted_9 = {
  class: "level-item flex items-center"
};
const _hoisted_10 = {
  class: "num"
};
const _hoisted_11 = {
  class: "unit"
};
const _hoisted_12 = {
  key: 1,
  class: "num"
};
const _hoisted_13 = {
  class: "level-item flex items-center"
};
const _hoisted_14 = {
  class: "num"
};
const _hoisted_15 = {
  class: "unit"
};
const _hoisted_16 = {
  key: 1,
  class: "num"
};
const _hoisted_17 = {
  class: "level-item flex items-center"
};
const _hoisted_18 = {
  class: "num"
};
const _hoisted_19 = {
  class: "unit"
};
const _hoisted_20 = {
  key: 1,
  class: "num"
};
import { bigdata } from "@/api/modules";
import { mapStore } from "@/store/map.js";

import { ref, watch, onMounted } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const {
      level,
      adcode
    } = mapStore();
    const nextLevelCount = ref();
    function getNextLevelCount() {
      bigdata.getNextLevelCount(adcode.value).then(({
        result
      }) => {
        // console.log("getNextLevelCount", result);
        nextLevelCount.value = result;
      });
    }
    watch(() => level.value, () => {
      getNextLevelCount();
    });
    onMounted(() => {
      getNextLevelCount();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("header", _hoisted_1, [_unref(nextLevelCount) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(level) === 1 ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [_createElementVNode("li", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0
      }, null, -1)), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(nextLevelCount)[0]?.regionTypeCount), 1), _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(nextLevelCount)[0]?.regionType), 1)]), _createElementVNode("li", _hoisted_6, [_cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_1
      }, null, -1)), _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(nextLevelCount)[1]?.regionTypeCount + _unref(nextLevelCount)[2]?.regionTypeCount + _unref(nextLevelCount)[3]?.regionTypeCount), 1), _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "unit"
      }, "个县(市、区)", -1))])])) : (_openBlock(), _createElementBlock("ul", _hoisted_8, [_createElementVNode("li", _hoisted_9, [_cache[3] || (_cache[3] = _createElementVNode("img", {
        src: _imports_0
      }, null, -1)), _unref(nextLevelCount)[0] ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", _hoisted_10, _toDisplayString(_unref(nextLevelCount)[0]?.regionTypeCount), 1), _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(nextLevelCount)[0]?.regionType), 1)], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))]), _createElementVNode("li", _hoisted_13, [_cache[4] || (_cache[4] = _createElementVNode("img", {
        src: _imports_2
      }, null, -1)), _unref(nextLevelCount)[1] ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", _hoisted_14, _toDisplayString(_unref(nextLevelCount)[1]?.regionTypeCount), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(nextLevelCount)[1]?.regionType), 1)], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))]), _createElementVNode("li", _hoisted_17, [_cache[5] || (_cache[5] = _createElementVNode("img", {
        src: _imports_1
      }, null, -1)), _unref(nextLevelCount)[2] ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", _hoisted_18, _toDisplayString(_unref(nextLevelCount)[2]?.regionTypeCount), 1), _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(nextLevelCount)[2]?.regionType), 1)], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))])]))], 64)) : _createCommentVNode("", true)]);
    };
  }
};